var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7903 17.6257C24.4721 17.6257 23.3975 18.6824 23.374 19.9978L23.3506 21.3103C23.3457 21.5864 23.1179 21.8062 22.8418 21.8013C22.8221 21.801 22.8025 21.7995 22.7831 21.7968L21.4825 21.6194C19.7712 21.3861 18.1311 20.5984 16.5576 19.2874C16.0593 22.0454 17.032 23.9567 19.3766 25.4306L20.8324 26.3458C21.0662 26.4928 21.1365 26.8015 20.9896 27.0352C20.9559 27.0888 20.9123 27.1355 20.8612 27.1728L19.5349 28.1419C20.3235 28.1915 21.0732 28.1569 21.6945 28.0329C25.6259 27.2483 28.2401 24.2898 28.2401 19.4099C28.2401 19.0114 27.3965 17.6257 25.7903 17.6257ZM21.7076 19.968C21.7473 17.7471 23.56 15.959 25.7903 15.959C26.9264 15.959 27.9541 16.423 28.6944 17.1718C29.2872 17.1673 29.7915 17.3172 30.9183 16.6337C30.6398 18.0007 30.5015 18.594 29.9068 19.4099C29.9068 25.7778 25.9925 28.8747 22.0207 29.6673C19.2976 30.2107 15.3374 29.3185 14.2031 28.1328C14.781 28.0884 17.1314 27.8357 18.4895 26.8416C17.3403 26.0828 12.7665 23.3907 15.7718 16.156C17.183 17.8032 18.6137 18.9244 20.0638 19.5197C21.0283 19.9156 21.2652 19.9077 21.7076 19.968Z",
    fill: "#0A0A13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d49daa54c6412c310bd62ece509d5675.svg";
export { ForwardRef as ReactComponent };